import {Injectable} from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import {environment} from '../../../../../environments/environment';
import {Subject, Observable, BehaviorSubject, combineLatest} from 'rxjs';
import {map, tap, shareReplay} from 'rxjs/operators';
import { Meta } from 'src/app/_models/meta';

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class MapaCurricularService {

  mcp$ = this.http.get<any[]>(`${API_URL}/api/materias/mcp`).pipe(shareReplay(1));

  materias$ = this.http.get<any[]>(`${API_URL}/api/materias`).pipe(shareReplay(1));

  private subject = new Subject<any>();

  private nuevasMetasSubject = new BehaviorSubject<Meta[]>([]);
  nuevasMetas$ = this.nuevasMetasSubject.asObservable();
  constructor(private http: HttpClient) {
  }

  setEstadoConexion(objCon) {
    return this.http.post(`${API_URL}/api/${objCon.url}`, objCon, {});
  }

  emitAbrirModal(objetoId, tipoObjeto) {
    let url;
    if (tipoObjeto === 'meta') {
      url = `${API_URL}/api/Metas/${objetoId}`;
    } else if (tipoObjeto === 'unidad') {
      url = `${API_URL}/api/Unidades/${objetoId}`;
    }
    this.http.get<HttpResponse<any[]>>(url).subscribe(objectResp => {
      this.subject.next({tipo: 'abrir-modal', objeto: objectResp, tipoObjeto: tipoObjeto});
    });
  }

  estadoAccionesMasivas(estado) {
    this.subject.next({tipo: 'acciones-masivas', estado});
  }

  guardarAccionMasiva(accion, ids) {
    const url = accion.indexOf('metas') > -1 ? 'Metas/activar' : '',
      estado = accion.indexOf('desactivar') > -1 ? false : accion.indexOf('activar') > -1 ? true : false,
      objAccion = {ids, estado};

    return this.http.post(`${API_URL}/api/${url}`, objAccion, {});
  }

  getRelatedDocs(areas: number[], cursos: number[]) {
    let url = '';
    if (cursos.length > 0) {
      url = `${API_URL}/api/gdrive/area/${areas.join()}/cursos/${cursos.join()}`;
    } else {
      url = `${API_URL}/api/gdrive/area/${areas.join()}`;
    }
    return this.http.get(url);
  }

  getMetasOrigen(idsMaterias, idsCursos, nivel = 4) {
    // return this.http.get<any[]>(`${API_URL}/api/metas/curriculo/materias/${idsMaterias}/cursos/${idsCursos}/nivel/${nivel}`);
    return combineLatest([
      this.http.get<any[]>(`${API_URL}/api/metas/curriculo/materias/${idsMaterias}/cursos/${idsCursos}/nivel/${nivel}`),
      this.nuevasMetas$
    ]).pipe(
      map(([metas, nuevasMetas]) => {
        if (nuevasMetas.length > 0) {
          return nuevasMetas;
        } else {
          return metas;
        }
      })
    );
  }

  getMetas(idsMaterias, idsCursos, nivel = 4) {
    // return this.http.get<any[]>(`${API_URL}/api/metas/curriculo/materias/${idsMaterias}/cursos/${idsCursos}/nivel/${nivel}`);
    return this.http.get<any[]>(`${API_URL}/api/metas/curriculo/materias/${idsMaterias}/cursos/${idsCursos}/nivel/${nivel}`);
  }

  getUnidades(idsMaterias, idsCursos, idPeriodo = 0) {
    return this.http.get<any[]>(`${API_URL}/api/unidades/buscar/materias/${idsMaterias}/cursos/${idsCursos}/periodo/${idPeriodo}`)
      .pipe(
        map(unidades => {
          return unidades;
        })
      );
  }

  getMCP(id = 0) {
    if (id === 0) {
      return this.mcp$;
    }
  }

  getMapaCurricularObservable(): Observable<any> {
    return this.subject.asObservable();
  }

  buscarMetas(id: number, termino: string, nivel: string, materias: string, cursos: string, ambitos: string, tags: string) {
    return this.http.get<Meta[]>(`${API_URL}/api/Metas/buscar/${id}/termino/${termino}/nivel/${nivel}/materias/${materias}/cursos/${cursos}/ambitos/${ambitos}/tags/${tags}`);
  }

  importarMetas(metas: Meta[]) {
    return this.http.post<Meta[]>(`${API_URL}/api/Metas/importar`, metas).pipe(
      tap(data => {
        this.nuevasMetasSubject.next(data);
      })
    );
  }
}
